import React from 'react'
import { useStyles } from './styles'
import { Backdrop, CircularProgress, Grid, Skeleton } from '@mui/material'

type ChartSkeletonBaseProps = {
  loading?: boolean
  progress?: number
  height?: number
  progressDetails?: React.ReactElement
  showLoadingPercent?: boolean
  barCount?: number
  getBarHeight: (index: number, height?: number) => number
  hideLoadingSpinner?: boolean
}

/**
 * A base skeleton component for charts, providing a loading state with a backdrop and skeleton bars.
 */
export const ChartSkeletonBase: React.FC<ChartSkeletonBaseProps> = ({
  loading,
  progress,
  height,
  progressDetails,
  showLoadingPercent = true,
  barCount = 10,
  getBarHeight,
  hideLoadingSpinner,
}) => {
  const { classes } = useStyles()

  return (
    <Grid
      container
      justifyContent="center"
      spacing={2}
      alignItems="flex-end"
      alignContent="flex-end"
      style={{ height: height ?? '100%', minHeight: 250, position: 'relative' }}
    >
      {(loading || progress) && !hideLoadingSpinner && (
        <Backdrop open classes={{ root: classes.limitedBackdrop }}>
          {loading && <CircularProgress sx={{ margin: '0 auto' }} />}
          {showLoadingPercent && progress !== undefined && `${(progress * 100).toFixed(2)}%`}
          {progressDetails}
        </Backdrop>
      )}
      {Array.from({ length: barCount }).map((_, index) => (
        <Grid key={index} item xs={1}>
          <Skeleton variant="rectangular" height={getBarHeight(index, height)} />
        </Grid>
      ))}
    </Grid>
  )
}
